import { Link } from "react-router-dom";
import { ArrowRight, Landmark, Cctv, Sparkles } from "lucide-react";
import { Reveal, SectionHeading, Corners } from "./Reveal";

const PRODUCTS = [
  {
    n: "01",
    icon: Landmark,
    name: "LAIC",
    tag: "LGU AI Companion — e-governance",
    desc: "Your whole city. Online. The complete e-governance platform that brings every LGU office, service, and transaction into one intelligent system.",
    img: "/media/frames/shot-map.jpg",
    to: "/products/laic",
    cta: "Explore LAIC",
    testId: "product-card-laic",
  },
  {
    n: "02",
    icon: Cctv,
    name: "MAC AI Vision",
    tag: "Camera intelligence — cities & campuses",
    desc: "The AI layer that watches every camera you already own — clearer roads and public spaces for LGUs, faster emergency response for schools.",
    img: "/media/frames/shot-junction.jpg",
    to: "/products/vision",
    cta: "Explore MAC AI Vision",
    testId: "product-card-vision",
  },
];

export default function ProductsGrid() {
  return (
    <section id="products" data-testid="products-section" className="relative border-t border-white/5 py-20 lg:py-36">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <SectionHeading
          index="01"
          eyebrow="The Portfolio"
          title={<>Products, not <span className="text-mac-accent">promises</span>.</>}
          sub="Two flagship products live today — with more AI solutions for institutions in active development."
          testId="products-heading"
        />

        <div className="grid gap-6 md:grid-cols-3">
          {PRODUCTS.map((p, i) => (
            <Reveal key={p.n} delay={i * 0.12}>
              <Link to={p.to} data-testid={p.testId} className="group relative block border border-white/10 bg-mac-surface/60 transition-[border-color,box-shadow,transform] duration-300 hover:border-mac-accent/50 hover:shadow-[0_0_40px_rgb(var(--mac-accent-rgb)/0.12)]">
                <Corners />
                <div className="relative h-44 overflow-hidden border-b border-white/10">
                  <img src={p.img} alt={p.name} loading="lazy" className="h-full w-full object-cover opacity-60 saturate-[0.5] transition-[opacity,transform] duration-500 group-hover:scale-105 group-hover:opacity-80" />
                  <div className="absolute inset-0 bg-mac-base/30" />
                  <span className="absolute left-4 top-4 border border-mac-accent/50 bg-mac-base/70 px-2.5 py-1 font-mono text-[10px] uppercase tracking-[0.2em] text-mac-accent backdrop-blur-sm">
                    {p.n}
                  </span>
                </div>
                <div className="p-6 lg:p-7">
                  <p.icon className="mb-5 h-6 w-6 text-mac-accent" strokeWidth={1.5} />
                  <h3 className="font-display text-3xl font-bold uppercase tracking-wide text-white">{p.name}</h3>
                  <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">{p.tag}</p>
                  <p className="mt-4 text-sm leading-relaxed text-slate-400">{p.desc}</p>
                  <span className="mt-6 inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-mac-accent transition-colors duration-300 group-hover:text-white">
                    {p.cta} <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}

          <Reveal delay={0.24}>
            <Link to="/contact" data-testid="product-card-more" className="group relative flex h-full flex-col border border-dashed border-white/20 bg-mac-base/40 transition-[border-color,box-shadow] duration-300 hover:border-mac-accent/60 hover:shadow-[0_0_40px_rgb(var(--mac-accent-rgb)/0.1)]">
              <div className="flex flex-1 flex-col justify-center p-6 lg:p-7">
                <Sparkles className="mb-5 h-6 w-6 text-slate-500 transition-colors duration-300 group-hover:text-mac-accent" strokeWidth={1.5} />
                <h3 className="font-display text-2xl font-bold uppercase tracking-wide text-slate-300">
                  More Solutions —<br />In Development
                </h3>
                <p className="mt-4 text-sm leading-relaxed text-slate-500">
                  New AI products for institutions are in active development. Ask us what's next.
                </p>
                <span className="mt-6 inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-400 transition-colors duration-300 group-hover:text-mac-accent">
                  Ask us what's next <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" />
                </span>
              </div>
            </Link>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
